import { administrationHttpClient } from '../../../http/axios/axios-http-client';

const ENDPOINT = '/healer-profile-feedback';

export interface ProfilePreviewFeedbackGateway {
  create(healerId: string, healerFeedback: string): Promise<void>;
}

export class ProfilePreviewFeedbackGateway implements ProfilePreviewFeedbackGateway {
  async create(healerId: string, healerFeedback: string): Promise<void> {
    const response = await administrationHttpClient.request({
      url: ENDPOINT,
      method: 'POST',
      data: {
        healerId: healerId,
        healerFeedback: healerFeedback,
      },
    });

    return response.data;
  }
}
